/**
 * DTMComparisonBarChart — Grouped bar chart (two series side by side)
 * Use for: champions vs field, SF vs 1QB, before/after
 */
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { TOKENS, ChartFigure } from "./tokens";

export function DTMComparisonBarChart({
  data,           // [{ label, seriesA, seriesB }]
  title,
  subtitle,
  source,
  seriesAKey = "seriesA",
  seriesBKey = "seriesB",
  seriesAName = "Champions",
  seriesBName = "Field",
  seriesAColor = TOKENS.green,
  seriesBColor = TOKENS.greyBar,
  labelKey = "label",
  layout = "horizontal",
  height = 260,
  formatter = (v) => v,
  domain,
  className = "",
}) {
  const isVertical = layout === "vertical";

  return (
    <ChartFigure title={title} subtitle={subtitle} source={source} className={className}>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart
          data={data}
          layout={isVertical ? "vertical" : "horizontal"}
          margin={isVertical ? { left: 10, right: 20, top: 4, bottom: 4 } : { left: 0, right: 0, top: 8, bottom: 0 }}
          barGap={2}
        >
          {isVertical ? (
            <>
              <XAxis type="number" tick={{ fontSize: 10, fill: TOKENS.muted, fontFamily: TOKENS.mono }} domain={domain} tickFormatter={formatter} axisLine={false} tickLine={false} />
              <YAxis type="category" dataKey={labelKey} tick={{ fontSize: 11, fill: "#a3a3a3", fontFamily: TOKENS.body }} width={80} axisLine={false} tickLine={false} />
            </>
          ) : (
            <>
              <XAxis dataKey={labelKey} tick={{ fontSize: 10, fill: "#a3a3a3", fontFamily: TOKENS.body }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 10, fill: TOKENS.muted, fontFamily: TOKENS.mono }} domain={domain} tickFormatter={formatter} axisLine={false} tickLine={false} />
            </>
          )}
          <Tooltip contentStyle={TOKENS.tooltipStyle} formatter={(v) => formatter(v)} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
          <Legend
            iconType="square"
            iconSize={8}
            wrapperStyle={{ fontSize: 10, fontFamily: TOKENS.body, color: "#888" }}
          />
          <Bar dataKey={seriesAKey} name={seriesAName} fill={seriesAColor} radius={[3, 3, 0, 0]} maxBarSize={22} />
          <Bar dataKey={seriesBKey} name={seriesBName} fill={seriesBColor} radius={[3, 3, 0, 0]} maxBarSize={22} />
        </BarChart>
      </ResponsiveContainer>
    </ChartFigure>
  );
}
